import script from "./MazdaSoVersionPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaSoVersionPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaSoVersionPanel.vue?vue&type=style&index=0&id=c5111d56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5111d56"]])

export default __exports__